// extracted by mini-css-extract-plugin
export var breadcrumb = "_1l-3";
export var breadcrumbArrow = "_1l-4";
export var breadcrumbs = "_1l-0";
export var link = "_1l-5";
export var sm = "_1l-1";
export var xs = "_1l-2";